/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const KeynoteForMac32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <defs>
            <linearGradient id="prefix__a" x1="100.003%" x2=".233%" y1="50%" y2="50%">
                <stop offset="0%" stopColor="#708EA4" />
                <stop offset="35.69%" stopColor="#99A3AB" />
                <stop offset="57.57%" stopColor="#919498" />
                <stop offset="68.55%" stopColor="#BBBCBD" />
                <stop offset="83.61%" stopColor="#CCD2D6" />
                <stop offset="100%" stopColor="#33383C" />
            </linearGradient>
            <linearGradient id="prefix__b" x1="100.001%" x2=".001%" y1="49.997%" y2="49.997%">
                <stop offset="0%" stopColor="#6D899D" />
                <stop offset="34.63%" stopColor="#B2BABE" />
                <stop offset="52.78%" stopColor="#9A9A9E" />
                <stop offset="66.33%" stopColor="#A88F93" />
                <stop offset="81.45%" stopColor="#C8CDD2" />
                <stop offset="100%" stopColor="#2A2F31" />
            </linearGradient>
            <linearGradient id="prefix__c" x1="9.962%" x2="69.438%" y1="52.974%" y2="48.885%">
                <stop offset="0%" stopColor="#2A89F8" />
                <stop offset="100%" stopColor="#30C8FF" />
            </linearGradient>
            <linearGradient id="prefix__d" x1="50.003%" x2="50.003%" y1="0%" y2="64.84%">
                <stop offset=".096%" stopColor="#1B7FF7" />
                <stop offset="100%" stopColor="#64B9FF" />
            </linearGradient>
            <linearGradient id="prefix__e" x1="50.003%" x2="50.003%" y1=".003%" y2="100.003%">
                <stop offset="0%" stopColor="#012F7C" />
                <stop offset="100%" stopColor="#013EA1" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#969696"
                d="M22.687 0c3.2 0 4.363.356 5.525.985a6.677 6.677 0 012.803 2.803c.63 1.162.985 2.325.985 5.525v13.374c0 3.2-.356 4.363-.985 5.525a6.677 6.677 0 01-2.803 2.803c-1.162.63-2.325.985-5.525.985H9.313c-3.2 0-4.363-.356-5.525-.985a6.677 6.677 0 01-2.803-2.803C.355 27.05 0 25.887 0 22.687V9.313c0-3.2.356-4.363.985-5.525A6.677 6.677 0 013.788.985C4.95.355 6.113 0 9.313 0h13.374z"
            />
            <path
                fill={vars.white}
                d="M9.313.547h13.374c3.05 0 4.157.315 5.265.916a6.36 6.36 0 012.585 2.585c.601 1.108.916 2.215.916 5.265v13.374c0 3.05-.315 4.157-.916 5.265a6.36 6.36 0 01-2.585 2.585c-1.108.601-2.215.916-5.265.916H9.313c-3.05 0-4.157-.315-5.265-.916-1.108-.602-1.997-1.463-2.585-2.585-.588-1.121-.916-2.215-.916-5.265V9.313c0-3.05.315-4.157.916-5.265.602-1.108 1.463-1.997 2.585-2.585C5.169.875 6.263.547 9.313.547z"
            />
            <path fill="url(#prefix__a)" d="M15.179 13.128h1.641v14.085h-1.641z" />
            <path
                fill="#4D5255"
                d="M11.35 27.419c0-.055.014-.082.055-.082.315-.069 2.174-.11 4.445-.123h.3c2.27 0 4.13.054 4.445.123.027 0 .055.027.055.082 0 .068-1.518.068-3.57.068h-2.174c-2.038 0-3.556-.013-3.556-.068z"
            />
            <path
                fill="url(#prefix__b)"
                d="M11.419 27.35h9.162c.041 0 .069.028.069.069v.684c0 .04-.028.068-.069.068H11.42c-.041 0-.069-.027-.069-.068v-.684c0-.041.028-.069.069-.069z"
            />
            <path
                fill="#075ED6"
                d="M6.537 12.5l18.94.054.04.383a.55.55 0 01-.491.601H7.029a.55.55 0 01-.547-.547v-.054l.055-.438z"
            />
            <path
                fill="url(#prefix__c)"
                d="M8.356 3.966H23.63c.273 0 .492.191.533.465l1.286 8.068a.555.555 0 01-.452.63c-.027 0-.054.013-.082.013H7.07a.55.55 0 01-.547-.547c0-.027 0-.055.014-.082l1.285-8.069a.543.543 0 01.534-.478z"
            />
            <path
                fill={vars.white}
                d="M10.202 5.333h11.61c.273 0 .506.205.547.479l.697 6.017a.533.533 0 01-.478.602H9.518a.55.55 0 01-.547-.547v-.069l.697-6.017c.014-.26.247-.465.534-.465z"
            />
            <path
                fill="url(#prefix__d)"
                d="M8 11.897h16a.21.21 0 01.205.206v.273a.21.21 0 01-.205.205H8a.21.21 0 01-.205-.205v-.273A.21.21 0 018 11.897z"
            />
            <path
                fill="url(#prefix__e)"
                d="M7.932 12.17h16.136c.082 0 .137.056.137.138v.136c0 .082-.055.137-.137.137H7.932c-.082 0-.137-.055-.137-.137v-.136c0-.082.055-.137.137-.137z"
            />
            <path fill="#BA418B" d="M16 6.017c.424 0 .834.082 1.203.233L16 8.356V6.017z" />
            <path fill="#E6484C" d="M17.203 6.25c.41.177.78.437 1.067.752L16 8.356l1.203-2.106z" />
            <path fill="#F79D26" d="M18.27 7.002c.451.506.739 1.162.739 1.887v.123L16 8.356l2.27-1.354z" />
            <path fill="#FDC830" d="M16 8.356l3.009.656a2.822 2.822 0 01-.903 1.928L16 8.356z" />
            <path
                fill="#6BC150"
                d="M16 8.356l2.106 2.584a3.088 3.088 0 01-2.106.82c-1.34 0-2.462-.834-2.858-1.982L16 8.356z"
            />
            <path
                fill="#36C6F4"
                d="M16 6.017v2.339l-2.858 1.422a2.694 2.694 0 01-.15-.89c0-1.572 1.326-2.844 2.953-2.87H16z"
            />
        </g>
    </AccessibleSVG>
);

export default KeynoteForMac32;
